import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import IconCard from '../IconCard/IconCard';
import { FILTERKEYS } from '../constants';

const IconsList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup); 

  return (
    <Fragment>
      {dataKeys.map((group, i) => 
        <section key={`icon-group-${i}`} className="with-padding">
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul>
            {
              dataGroup[group].map((icon, i) => {
                return (
                  <IconCard icon={icon} key={`icon-${i}`} />
                );
              })
            }
          </ul>
        </section>
      )}
    </Fragment>
  );
};

IconsList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

IconsList.displayName = 'IconsList';

export default IconsList;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/IconsList/IconsList.js